import React, { PureComponent } from "react";
import { FirebaseAuthContext } from "../firebase/FirebaseAuthProvider";
import { Redirect } from "react-router-dom";

class RouterGuard extends PureComponent {
	render() {
		const { children } = this.props;
		return (
			<FirebaseAuthContext.Consumer>
				{({ isUserSignedIn }) => {
					if (isUserSignedIn) {
						return children;
					}
					return <Redirect to="/login" />;
				}}
			</FirebaseAuthContext.Consumer>
		);
	}
}

export default RouterGuard;
